<template>
    <toolbar-option>
        <template slot="primary">
            <button-group
                :value="slideFrom"
                :options="slideFromOptions"
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

const CUSTOM_ATTR_NAME = 'hamburger-nav-slide-direction';
const DEFAULT_VALUE = 'left';

export default {
    name: 'hamburger-nav-slide-direction',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Slide In',
            slideFrom: DEFAULT_VALUE,
            slideFromOptions: [
                { text: 'From Left', value: 'left' },
                { text: 'From Right', value: 'right' },
            ],
        };
    },

    methods: {
        onInput(slideFrom) {
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, slideFrom);
            this.slideFrom = slideFrom;
        },

        onSelectedElement() {
            this.slideFrom = this.selectedElements[0].getElementData(CUSTOM_ATTR_NAME);

            if (!this.slideFrom) {
                this.slideFrom = DEFAULT_VALUE;
                this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, DEFAULT_VALUE, { triggerChangeDetection: false });
            }
        },
    },
};
</script>
